/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaNotifications/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaNotifications({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaNotifications",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaNotifications.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZCyoRl': alignSelf,'--mt-2-ZCyoRl': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZCyoRl': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZCyoRl': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZCyoRl': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZCyoRl': opacity,'--w-10-ZCyoRl': typeof width === 'number' ? `${width}px` : width,'--h-11-ZCyoRl': typeof height === 'number' ? `${height}px` : height,'--a-7-ZCyoRl': isAnimated ? animation : "none",'--sd-8-ZCyoRl': isAnimated ? strokeDashoffset : 0,'--sd-9-ZCyoRl': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaNotifications.SvgPath"
  data-view-path={viewPath}
 d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
 style={{'--f-12-ZCyoRl': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}